import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { AllValidationErrors, FormErrorsService } from '../../service/form-errors.service';

@Component({
  selector: 'app-form-errors',
  templateUrl: './form-errors.component.html',
  styleUrls: ['./form-errors.component.scss']
})
export class FormErrorsComponent implements OnInit {

  @Input()
  form: FormGroup | FormArray;

  constructor(
    private formErrorsService: FormErrorsService
  ) { }

  ngOnInit(): void {
  }

  errors(): AllValidationErrors[] {
    if (this.form) {
      return this.formErrorsService.getErrors(this.form);
    }
    return [];
  }

}
